import { useTranslation } from 'react-i18next';

import type { CatalogServiceCustomField } from '@/types';

import { typedFields } from '@/components/Form';
import { InputLabel } from '@/components/InputLabel';

type ServiceCustomFieldValues = {
  custom_field_values: Record<string, string>;
};

type ServiceCustomFieldsProps = {
  fields: CatalogServiceCustomField[];
};

const formFields = typedFields<ServiceCustomFieldValues>();

export const ServiceCustomFields = (props: ServiceCustomFieldsProps) => {
  const { fields } = props;
  const { t } = useTranslation();

  if (fields.length === 0) {
    return null;
  }

  return (
    <div className="grid gap-3">
      <InputLabel label={t('Custom fields')} />

      {fields.map((field) => {
        if (field.field_type === 'dropdown') {
          return (
            <formFields.Select
              key={field.id}
              name={`custom_field_values.${field.id}`}
              label={field.label}
              isRequired={field.required}
              options={(field.option_values ?? []).map((option) => ({
                id: option,
                name: option,
              }))}
            />
          );
        }

        if (field.field_type === 'number') {
          return (
            <formFields.Input
              key={field.id}
              name={`custom_field_values.${field.id}`}
              label={field.label}
              isRequired={field.required}
              type="number"
            />
          );
        }

        return (
          <formFields.Textarea
            key={field.id}
            name={`custom_field_values.${field.id}`}
            label={field.label}
            isRequired={field.required}
          />
        );
      })}
    </div>
  );
};
